import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import {MatExpansionModule} from '@angular/material/expansion';
import {CdkMenuModule} from '@angular/cdk/menu';

import { MainTaxNavComponent } from './main-tax-nav.component';
import { createCustomElement } from "@angular/elements";
import { ESearchFilterComponent } from "@signature-it/ngx-entity/components/e-search/e-search-filter/e-search-filter.component";



@NgModule({
  declarations: [MainTaxNavComponent],
    imports: [
        CommonModule,
        RouterModule,
        MatExpansionModule,
        CdkMenuModule
    ],
    exports: [MainTaxNavComponent]
})
export class MainTaxNavModule {
    constructor(private injector: Injector) {
        !customElements.get('ngx-main-tax-nav') && customElements.define('ngx-main-tax-nav', createCustomElement(MainTaxNavComponent, {injector}));
    }
}
